import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppEventsService {

    public readonly APP_EVENT_ENUM = {
        LOGOUT: 'LOGOUT',
    }

    private appEvent: Subject<any> = new Subject();
    appEvent$ = this.appEvent.asObservable();

    announceAppEvent(eventName: string, data?: any): void {
        // console.log('AppEventsService announceAppEvent', eventName, data);
        this.appEvent.next({eventName, data});
    }


}
